import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Spin, Form, Divider, Col, Select } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import dayjs from "dayjs";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { apiConfig, labelConfig, staticConfig } from "../product.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;
const { TextArea } = Input;

const ViewCertificate = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [certificateDetail, setCertificateDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [templateTypeOptions, setTemplateTypeOptions] = useState([]);
  const [fixedDepositProducts, setFixedDepositProducts] = useState([]);
  const [recurringDepositProducts, setRecurringDepositProducts] = useState([]);
  const [moneyMarketProducts, setMoneyMarketProducts] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState([]);

  const productType = Form.useWatch("productType", useForm);
  const isDefault = Form.useWatch("isDefault", useForm);
  const productOptions =
    productType === 1
      ? moneyMarketProducts
      : productType === 2
        ? fixedDepositProducts
        : recurringDepositProducts;

  const getTemplate = () => {
    const url = `${apiConfig.certificateTemplates}/template`;
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
          setIsLoading(false);
        } else {
          const objList = res;
          let tempTemplateType = [];
          let tempProductType = [];
          let fixedDepositProducts = [];
          let recurringDepositProducts = [];
          let moneyMarketProducts = [];

          // Template Type Options
          objList?.templateTypeOptions?.forEach((element) => {
            tempTemplateType.push({
              value: element.value,
              label: element.text,
            });
          });

          // Product Type Options
          objList?.productTypeOptions?.forEach((element) => {
            tempProductType.push({
              value: element.value,
              label: element.text,
            });
          });

          // Fixed Deposit Product Options
          objList?.fixedDepositProducts?.forEach((element) => {
            fixedDepositProducts.push({
              value: element.id,
              label: element.name,
            });
          });

          // Recurring Deposit Product Options
          objList?.recurringDepositProducts?.forEach((element) => {
            recurringDepositProducts.push({
              value: element.id,
              label: element.name,
            });
          });

          // Money Market Product Options
          objList?.moneyMarketProducts?.forEach((element) => {
            moneyMarketProducts.push({
              value: element.id,
              label: element.name,
            });
          });

          setTemplateTypeOptions(tempTemplateType);
          setProductTypeOptions(tempProductType);
          setFixedDepositProducts(fixedDepositProducts);
          setRecurringDepositProducts(recurringDepositProducts);
          setMoneyMarketProducts(moneyMarketProducts);
        }
      },
      "treasury",
    );
  };

  const getDetailById = () => {
    if (!state?.id) {
      BOM.AlertMsg(cnt.DANGER, "Certificate template ID is missing");
      return;
    }

    setIsLoading(true);

    const url = `${apiConfig.certificateTemplates}/${state.id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage || err);
          setIsLoading(false);
        } else {
          const objDetail = res;

          // Format dates for display
          let effectiveFromValue = "-";
          let effectiveToValue = "-";

          if (objDetail?.effectiveFrom) {
            effectiveFromValue = dayjs(BOM.FormatArrayDate(objDetail.effectiveFrom)).format(
              "YYYY-MM-DD",
            );
          }
          if (objDetail?.effectiveTo) {
            effectiveToValue = dayjs(BOM.FormatArrayDate(objDetail.effectiveTo)).format(
              "YYYY-MM-DD",
            );
          }

          setCertificateDetail(objDetail);

          // Set form values for all fields including dropdowns
          useForm.setFieldsValue({
            templateName: objDetail?.templateName,
            templateCode: objDetail?.templateCode,
            templateType: objDetail?.templateType,
            description: objDetail?.description,
            htmlContent: objDetail?.htmlContent,
            productId: objDetail?.productId,
            productType: objDetail?.productType,
            isDefault: objDetail?.isDefault || false,
            effectiveFrom: effectiveFromValue,
            effectiveTo: effectiveToValue,
          });

          // ENABLE DELETE BUTTON

          // dispatch({
          // type: cnt.RIGHT_DELETE_BTN,
          if (
            objDetail?.templateStatusText?.toLowerCase() === "inactive" ||
            objDetail?.templateStatusText?.toLowerCase() === "draft"
          ) {
            dispatch({
              type: cnt.CLEAR_RIGHT_BTN,
            });
            [cnt.RIGHT_APPROVE_BTN, cnt.RIGHT_DELETE_BTN].forEach((item) => {
              dispatch({
                type: item,
              });
            });
          } else if (objDetail?.templateStatusText?.toLowerCase() === "active") {
            dispatch({
              type: cnt.CLEAR_RIGHT_BTN,
            });
            [cnt.RIGHT_REJECT_BTN].forEach((item) => {
              dispatch({
                type: item,
              });
            });
          }

          setIsLoading(false);
        }
      },
      "treasury",
    );
  };

  useEffect(() => {
    getTemplate();
    getDetailById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnDelete = () => {
    let action = "Close ";
    let label = certificateDetail.templateName;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + " " + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.certificateTemplates}/${certificateDetail.id}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage || err);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, "Certificate template deleted successfully");
              navigate("/certificate-template");
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/certificate-template");
              setIsLoading(false);
            },
          },
          "treasury",
        );
      },
      function () {
        // No button
      },
    );
  };

  function handleOnApprove() {
    let action = "Activate";
    let certificateName = certificateDetail.templateName;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + " " + certificateName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = { command: "approve" };

        try {
          // Single row submission
          let body = {
            method: "POST",
            session,
            params,
          };

          const url = `${apiConfig.certificateTemplates}/${state.id}?command=activate`;

          BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              getDetailById();
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, "Certificate template activated successfully");
              getDetailById();
              //STOP LOAD
              setIsLoading(false);
            }
          });
        } catch (error) {
          console.error(error);
        }
      },

      function () {
        // No button
      },
    );
  }

  function handleOnReject() {
    let action = "Deactivate ";
    let certificateName = certificateDetail.templateName;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + " " + certificateName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = {
          command: "reject",
        };

        try {
          let body = {
            method: "POST",
            session,
            params,
          };

          const url = `${apiConfig.certificateTemplates}/${state.id}?command=deactivate`;

          BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              getDetailById();
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, "Certificate template deactivated successfully");
              getDetailById();
              //STOP LOAD
              setIsLoading(false);
            }
          });
        } catch (error) {
          console.error(error);
        }
      },

      function () {
        // No button
      },
    );
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onDelete={handleOnDelete}
      onApprove={handleOnApprove}
      onReject={handleOnReject}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.viewCertificateTemplate}
        pageItems={
          state?.variant
            ? staticConfig.viewCertificateTemplateItems
            : staticConfig.detailCertificateTemplateItems
        }
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                Certificate Template Setup
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text strong>{labelConfig.templateName}</Text>}
                  name="templateName"
                >
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text strong>{labelConfig.templateCode}</Text>}
                  name="templateCode"
                >
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text strong>{labelConfig.templateType}</Text>}
                  name="templateType"
                >
                  <Select disabled options={templateTypeOptions} showSearch />
                </Form.Item>
              </Col>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form.Item label={<Text strong>{labelConfig.description}</Text>} name="description">
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form.Item label={<Text strong>{labelConfig.htmlContent}</Text>} name="htmlContent">
                  <TextArea rows={10} disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={<Text strong>{labelConfig.productType}</Text>} name="productType">
                  <Select disabled options={productTypeOptions} showSearch />
                </Form.Item>
              </Col>
              {!isDefault && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text strong>{labelConfig.productId}</Text>} name="productId">
                    <Select
                      disabled
                      options={productOptions}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={<Text strong>{labelConfig.isDefault}</Text>} name="isDefault">
                  <Select disabled options={staticConfig.templateStatusData} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text strong>{labelConfig.effectiveFrom}</Text>}
                  name="effectiveFrom"
                >
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={<Text strong>{labelConfig.effectiveTo}</Text>} name="effectiveTo">
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>

        <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCertificate);
